import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content" style={{ overflowY: "inherit" }}>

                <section className="wide-tb-100 pt-0 bg-white home-welcome">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-3">
                                <div className="icon-box-7">
                                    <img src="images/icon-box-six-1.jpg" alt="" />
                                    <h3 className="h3-xs txt-blue">Ground<br />Delivery</h3>
                                    <a href="service-details.html" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                </div>
                                <p className="text-center">Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>
                            </div>

                            <div className="col-md-3">
                                <div className="icon-box-7">
                                    <img src="images/icon-box-six-2.jpg" alt="" />
                                    <h3 className="h3-xs txt-blue">AIR<br />DELIVERY</h3>
                                    <a href="service-details.html" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                </div>
                                <p className="text-center">Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>
                            </div>

                            <div className="col-md-3">
                                <div className="icon-box-7">
                                    <img src="images/icon-box-six-3.jpg" alt="" />
                                    <h3 className="h3-xs txt-blue">Sea<br />Delivery</h3>
                                    <a href="service-details.html" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                </div>
                                <p className="text-center">Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>
                            </div>

                            <div className="col-md-3">
                                <div className="icon-box-7">
                                    <img src="images/icon-box-six-4.jpg" alt="" />
                                    <h3 className="h3-xs txt-blue">Packaging &<br />Storage</h3>
                                    <a href="service-details.html" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                </div>
                                <p className="text-center">Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>
                            </div>

                        </div>
                    </div>
                </section>

                <section className="bg-light-gray wide-tb-100">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="img-business-man">
                                <img src="images/courier-man.png" alt="" />
                            </div>
                            <div className="col-md-6 ml-auto">
                                <div className=" wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                    <h1 className="heading-main text-left mb-5">
                                        <span>WHO WE ARE</span>
                                        About Us
                                    </h1>
                                </div>

                                <p className="lead fw-5 txt-blue">Whether you require distribution or fulfillment, defined freight forwarding, or a complete supply chain solution, we are here for you.</p>

                                <div className="mt-5">
                                    <ul className="nav nav-pills theme-tabbing mb-3" id="pills-tab" role="tablist">
                                        <li className="nav-item">
                                            <a className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">About us</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Our History</a>
                                        </li>
                                    </ul>
                                    <div className="tab-content theme-tabbing" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                            <p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. </p>
                                            <p>We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach. Dramatically visualize customer directed convergence without revolutionary ROI.</p>
                                        </div>
                                        <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                            <p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. </p>
                                            <p>Dramatically visualize customer directed convergence without revolutionary ROI.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="bg-white wide-tb-100">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="col-sm-12">
                                <h1 className="heading-main wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                    <span>Our Features</span>
                                    Why Choose Us
                                </h1>
                            </div>

                            <div className="col-12 col-lg-4">
                                <div className="icon-box-2 mb-4">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-check-circled"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Worldwide Locations</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-check-circled"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Quality and Commitment</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-4">
                                <img src="images/truck_front.jpg" alt="" />
                            </div>

                            <div className="col-12 col-lg-4">
                                <div className="icon-box-2 mb-4">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-check-circled"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">24/7 Customer Support</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-check-circled"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">100% Safe Delivery</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="wide-tb-100 bg-fixed free-quote free-quote-alt pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-7">
                                <div className="free-quote-form">
                                    <h1 className="heading-main mb-4">
                                        <span>Request a </span>
                                        Free Quote
                                    </h1>

                                    <form action="#" method="post" noValidate="novalidate" className="col rounded-field">
                                        <div className="form-row mb-4">
                                            <input type="text" name="name" className="form-control" placeholder="Your Name" />
                                        </div>
                                        <div className="form-row mb-4">
                                            <input type="text" name="email" className="form-control" placeholder="Email" />
                                        </div>
                                        <div className="form-row mb-4">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Transport Type</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                        <div className="form-row mb-4">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Type of freight</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                        <div className="form-row mb-4">
                                            <textarea rows="7" placeholder="Message" className="form-control"></textarea>
                                        </div>
                                        <div className="form-row text-center">
                                            <button type="submit" className="form-btn mx-auto btn-theme bg-secondary">Submit Now <i className="icofont-rounded-right"></i></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-white wide-tb-100">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>our Gallery</span>
                                    Photo Showcase
                                </h1>
                            </div>
                        </div>

                        <div id="js-styl2-mosaic" className="cbp">
                            <div className="cbp-item design">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-1.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-1.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="cbp-item design">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-2.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
            ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-2.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="cbp-item illustration">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-3.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
            ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-3.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="cbp-item photography">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-7.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
            ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-7.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="cbp-item identity">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-8.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
            ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-8.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="cbp-item business">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-9.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
            ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-9.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="cbp-item photography">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-10.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-10.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="cbp-item business">
                                <div className="gallery-link">
                                    <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/fullwidth/img-11.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/fullwidth/img-11.jpg" alt="" />
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="bg-sky-blue wide-tb-100 pb-5">
                    <div className="container pos-rel">
                        <div className="contact-map-bg">
                            <img src="images/map-bg.png" alt="" />
                        </div>
                        <div className="row piecharts" id="pie-charts">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>Number We love</span>
                                    Our Fun Facts
                                </h1>
                            </div>
                            <div className="col-sm-4 col-lg-2 col-md-4 col-6">
                                <span className="chart" data-percent="90">
                                    <span className="percent"></span>
                                </span>
                                <div className="skill-name">Road Transport</div>
                            </div>

                            <div className="col-sm-4 col-lg-2 col-md-4 col-6">
                                <span className="chart" data-percent="90">
                                    <span className="percent"></span>
                                </span>
                                <div className="skill-name">Logistics</div>
                            </div>

                            <div className="col-sm-4 col-lg-2 col-md-4 col-6">
                                <div className="chart" data-percent="95">
                                    <span className="percent"></span>
                                </div>
                                <div className="skill-name">Truck Rental</div>
                            </div>

                            <div className="col-sm-4 col-lg-2 col-md-4 col-6">
                                <span className="chart" data-percent="66">
                                    <span className="percent"></span>
                                </span>
                                <div className="skill-name">Courier</div>
                            </div>
                            <div className="col-sm-4 col-lg-2 col-md-4 col-6">
                                <span className="chart" data-percent="85">
                                    <span className="percent"></span>
                                </span>
                                <div className="skill-name">Air Transport</div>
                            </div>
                            <div className="col-sm-4 col-lg-2 col-md-4 col-6">
                                <span className="chart" data-percent="86">
                                    <span className="percent"></span>
                                </span>
                                <div className="skill-name">Support</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 mb-spacer-md">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>What Our</span>
                                    Customers Saying
                                </h1>
                            </div>
                            <div className="col-sm-12">
                                <div className="owl-carousel owl-theme" id="home-client-testimonials">

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_1.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_2.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_3.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 bg-light-gray">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>SOME OF OUR</span>
                                    Clients
                                </h1>
                            </div>

                            <div className="col-md-4 col-sm-12">
                                <div className="pricing-table bg-white">
                                    <div className="txt-blue fw-6">Starter</div>
                                    <div className="service-icon mx-auto">
                                        <i className="icofont-briefcase-1"></i>
                                    </div>
                                    <div className="pricing">
                                        10<sup>$</sup>
                                    </div>

                                    <ul className="list-unstyled">
                                        <li><strong>10GB</strong> Disk Space</li>
                                        <li><strong>100GB</strong> Monthly Bandwidth</li>
                                        <li><strong>20</strong> Email Accounts</li>
                                        <li><strong>Unlimited</strong> subdomains</li>
                                    </ul>

                                    <a href="#" className="btn-theme bg-secondary">Signup Now</a>
                                </div>
                            </div>

                            <div className="col-md-4 col-sm-12">
                                <div className="pricing-table bg-white best-seller">
                                    <div className="txt-blue fw-6">Professional</div>
                                    <div className="service-icon mx-auto">
                                        <i className="icofont-headphone-alt-3"></i>
                                    </div>
                                    <div className="pricing">
                                        40<sup>$</sup>
                                    </div>

                                    <ul className="list-unstyled">
                                        <li><strong>Unlimited</strong> Disk Space</li>
                                        <li><strong>Unlimited</strong> Monthly Bandwidth</li>
                                        <li><strong>Unlimited</strong> Email Accounts</li>
                                        <li><strong>Unlimited</strong> subdomains</li>
                                    </ul>

                                    <a href="#" className="btn-theme bg-primary">Signup Now</a>
                                </div>
                            </div>

                            <div className="col-md-4 col-sm-12">
                                <div className="pricing-table bg-white">
                                    <div className="txt-blue fw-6">Basic</div>
                                    <div className="service-icon mx-auto">
                                        <i className="icofont-paint"></i>
                                    </div>
                                    <div className="pricing">
                                        20<sup>$</sup>
                                    </div>

                                    <ul className="list-unstyled">
                                        <li><strong>2GB </strong> Disk Space</li>
                                        <li><strong>25GB</strong> Monthly Bandwidth</li>
                                        <li><strong>5</strong> Email Accounts</li>
                                        <li><strong>Unlimited</strong> subdomains</li>
                                    </ul>

                                    <a href="#" className="btn-theme bg-secondary">Signup Now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h1 className="heading-main">
                                    <span>COMPANY'S NEWS</span>
                                    Recent Posts
                                </h1>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_1.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_2.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInRight" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_3.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 bg-fixed clients-bg pos-rel">
                    <div className="bg-overlay blue opacity-80"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>SOME OF OUR</span>
                                    Clients
                                </h1>
                            </div>

                            <div className="col-sm-12 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="owl-carousel owl-theme" id="home-clients">

                                    <div className="item">
                                        <img src="images/clients/client1.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client2.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client3.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client4.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client5.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client6.png" alt="" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="map-bg">
                    <div className="contact-details row d-flex">
                        <div className="col">
                            <h4>Germany</h4>
                            <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                            <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">germany@logzee.com</a></div>
                        </div>
                        <div className="col">
                            <h4>Spain</h4>
                            <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                            <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">spain@logzee.com</a></div>
                        </div>
                    </div>
                    <div id="map-holder" className="pos-rel">
                        <div id="map_extended">
                            <p>This will be replaced with the Google Map.</p>
                        </div>
                    </div>
                </section>

            </main>
        </>
    );
};
export default Content;
